<template>
  <div class="google-map-wrapper">
    <div
      class="google-map"
      ref="googleMap"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import { POINT_MARKER_ICON_TRAM, POINT_MARKER_ICON_BUS } from "../constants/mapSettings";

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    markers: Object,
    visible: Array
  },

  data() {
    return {
      google: null,
      map: null,
      infoWindow: null,
      mapMarkers: {}
    };
  },

  watch: {
    markers: function (markers, oldVal) {
        this.initializeMarkers();
    },
    visible: function (markers, oldVal) {
      for (let key in this.mapMarkers) {
        let marker = this.mapMarkers[key]
        if (!this.visible.includes(marker._data.line_type)) {
          this.mapMarkers[key].setVisible(false)
        } else {
          this.mapMarkers[key].setVisible(true)
        }
      }
    }
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey
    });
    this.google = googleMapApi;
    this.initializeMap();
    this.initializeMarkers();
  },

  methods: {
    initializeMap() {
      const { Map, InfoWindow } = this.google.maps;
      const mapContainer = this.$refs.googleMap;
      this.map = new Map(mapContainer, this.mapConfig);
      /*let self = this
      this.google.maps.event.addListener(self.map, 'zoom_changed', function () {
        if (self.map.getZoom() >= 13) self.showMarkers();
        if (self.map.getZoom() < 13) self.hideMarkers();
      });*/
      this.infoWindow = new InfoWindow({
        content: ''
      });
    },
    initializeMarkers() {
      if (this.google === null) {
        return
      }
      const { Marker } = this.google.maps;
      let self = this

      // Add or Update markers
      for (let key in this.markers) {
        let marker = this.markers[key]
        if (this.mapMarkers.hasOwnProperty(key)) {
          this.mapMarkers[key].setPosition(
              marker.position
          );
        } else {
          let icon = null
          if (marker.line_type === 'E') {
            icon = POINT_MARKER_ICON_TRAM
          } else if (marker.line_type === 'A') {
            icon = POINT_MARKER_ICON_BUS
          }
          this.mapMarkers[key] = new Marker({
            position: marker.position,
            map: this.map,
            icon: icon,
            _data: marker
          })
          if (!this.visible.includes(marker.line_type)) {
            this.mapMarkers[key].setVisible(false)
          }
          this.mapMarkers[key].addListener('click', function() {
            let marker = self.mapMarkers[key]
            self.infoWindow.open(self.map, marker)
            let content = [
                '<strong>Linka:</strong> ' + marker._data.line
            ]
            let delay = marker._data.delay
            if (delay > 0 && delay < 60) {
              content.push('<strong>Meškanie: </strong>  < 1min')
            } else if (delay >= 60) {
              content.push('<strong>Meškanie: </strong>' + Math.floor(marker._data.delay/60) + ' min')
            }
            if (marker._data.from !== undefined && marker._data.to !== undefined) {
              content.push('<strong>Smer: </strong> ' + marker._data.from + ' <strong>&#8250;</strong> ' + marker._data.to)
            } else if (marker._data.from !== undefined) {
              content.push('<strong>Smer: </strong> ' + marker._data.from)
            }
            self.infoWindow.setContent(content.join('<br />'))
          })
        }
      }

      // Remove markers
      for (let key in this.mapMarkers) {
        if (!this.markers.hasOwnProperty(key)) {
          this.mapMarkers[key].setMap(null)
          delete this.mapMarkers[key]
        }
      }
    },
    showMarkers() {
      for (let key in this.mapMarkers) {
        this.mapMarkers[key].setVisible(true)
      }
    },
    hideMarkers() {
      for (let key in this.mapMarkers) {
        this.mapMarkers[key].setVisible(false)
      }
    }
  }
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// components/GoogleMapLoader.vue